

export default function NotFound() {

    return (
        <div className="text-center">
            404 : Not Found
        </div>
    );

}